// src/utils/geolocationLayer.ts
import { Map } from 'ol'
import { Feature } from 'ol'
import { Point } from 'ol/geom'
import { Style, Icon } from 'ol/style'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import { fromLonLat } from 'ol/proj'

export const addGeolocationLayer = (map: Map) => {
  if (!navigator.geolocation) {
    console.error('Geolocalização não é suportada pelo navegador.')
    return
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords
      const coordinates = fromLonLat([longitude, latitude])

      // Cria uma feature representando a localização do usuário
      const geolocationFeature = new Feature({
        geometry: new Point(coordinates),
      })

      // Define o estilo do ícone de localização
      geolocationFeature.setStyle(
        new Style({
          image: new Icon({
            src: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
            scale: 0.1, // Ajuste de tamanho do ícone
          }),
        })
      )

      const vectorSource = new VectorSource({
        features: [geolocationFeature],
      })

      const geolocationLayer = new VectorLayer({
        source: vectorSource,
      })

      geolocationLayer.set('name', 'MY_LOCATION')
      geolocationLayer.setZIndex(3)

      // Adiciona a camada ao mapa
      map.addLayer(geolocationLayer)

      // Centraliza o mapa na localização do usuário e ajusta o zoom
      // map.getView().setCenter(coordinates)
      // map.getView().setZoom(15)
    },
    (error) => {
      console.error('Erro ao obter localização:', error)
    }
  )
}
